"use client"
import { Button, Typography } from "@mui/material"
import NextLink from "common/bit/NextLink"
import styled from "styled-components"
import { StyledPageWrapper } from "theme/shared"

const StyledPageDiv = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: row;
  display: flex;
  align-items: center;
  max-width: 1400px;
  padding: 100px;
  h2 {
    margin-top: 10px;
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    flex-direction: column-reverse;
    padding: 0px;
    padding-top: 70px;
    padding-bottom: 50px;
    padding-left: 16px;
    padding-right: 16px;
    p {
      margin-top: 100px;
    }
  }
`

const StyledWrapper = styled.div`
  width: 50%;
  height: 100%;
  img {
    ${(p) => p.theme.breakpoints.up("md")} {
      width: 549px;
      height: 364px;
    }
  }
  ${(p) => p.theme.breakpoints.down("sm")} {
    width: 100%;
  }
`

const StyledImage = styled.img`
  width: 100%;
`

const StyledButtonWrapper = styled.div`
  margin-top: 30px;
`

const StyledHomeButton = styled(Button)`
  width: 91px;
  height: 45px;
  background: ${(p) => p.theme.colors.black};
  color: ${(p) => p.theme.colors.white};
  margin-right: 10px;
`

const StyledModelsButtons = styled(Button)`
  width: 150px;
  height: 45px;
  background: ${(p) => p.theme.colors.white};
  color: ${(p) => p.theme.colors.black};
`

const Page404 = () => {
  return (
    <StyledPageWrapper $padding={"0"} $background="#F5F5F5">
      <StyledPageDiv>
        <StyledWrapper>
          <Typography variant="body1">הכתובת לא הובילה לשום מקום</Typography>
          <Typography variant="h2">
            לאן רצית להגיע? נביא אותך לשם בבטחה
          </Typography>
          <StyledButtonWrapper>
            <NextLink href="/models">
              <StyledModelsButtons>לדגמי MAZDA</StyledModelsButtons>
            </NextLink>
            <NextLink href="/">
              <StyledHomeButton>לדף הבית</StyledHomeButton>
            </NextLink>
          </StyledButtonWrapper>
        </StyledWrapper>
        <StyledWrapper>
          <StyledImage src={"/img/404.png"} alt="page-cover-img" />
        </StyledWrapper>
      </StyledPageDiv>
    </StyledPageWrapper>
  )
}

export default Page404
